import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { LockerApiService } from '../../api/locker-api.service';
import { inject } from '@angular/core';
import { GetLockerHistoryOutput } from '../../api/locker-api.types';

export const lockerHistoryResolver: ResolveFn<GetLockerHistoryOutput> = (
  route: ActivatedRouteSnapshot,
) => {
  return inject(LockerApiService).getLockerHistory(+route.paramMap.get('id')!);
};
